import { _js } from '@ifixit/localize';
import { Undo } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const UndoButton = (props: any) => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().undo().run()}
         isDisabled={!editor.can().undo()}
         icon={<Undo />}
         title={_js('Undo')}
         shortcut={'z'}
      ></TiptapButton>
   );
};
